<header class="fixed inset-x-0 top-0 z-50 border-b border-line bg-surface/95 backdrop-blur-sm">
  <nav class="site-container flex h-20 items-center justify-between gap-6" aria-label="Principal">
    <a appSectionLink="hero" (click)="menuOpen.set(false)" class="shrink-0" aria-label="Medviz, voltar ao início">
      <img
        src="assets/images/logo/Medviz-inline-color-on-black.png"
        alt="Medviz"
        width="360"
        height="87"
        class="h-8 w-auto sm:h-9"
      />
    </a>

    <ul class="hidden items-center gap-8 lg:flex">
      @for (link of links; track link.section) {
        @let active = activeSection() === link.section;
        <li>
          <a
            [appSectionLink]="link.section"
            [attr.aria-current]="active ? 'location' : null"
            class="border-b-2 pb-1 text-sm font-bold transition-colors duration-200 hover:text-gold"
            [class.border-primary]="active"
            [class.text-primary]="active"
            [class.border-transparent]="!active"
            [class.text-muted]="!active"
          >
            {{ link.label }}
          </a>
        </li>
      }
    </ul>

    <div class="flex items-center gap-2">
      <a
        appSectionLink="contato"
        class="hidden rounded-lg bg-primary px-6 py-2.5 text-sm font-bold text-white transition-all hover:bg-primary-hover active:scale-95 sm:inline-flex"
      >
        Agendar demonstração
      </a>
      <button
        type="button"
        class="-mr-2 flex size-11 items-center justify-center rounded-lg text-primary hover:bg-canvas lg:hidden"
        (click)="menuOpen.set(!menuOpen())"
        [attr.aria-expanded]="menuOpen()"
        aria-controls="menu-mobile"
        [attr.aria-label]="menuOpen() ? 'Fechar menu' : 'Abrir menu'"
      >
        <app-icon [name]="menuOpen() ? 'close' : 'menu'" class="text-3xl" />
      </button>
    </div>
  </nav>

  @if (menuOpen()) {
    <div id="menu-mobile" class="border-t border-line bg-surface shadow-ambient lg:hidden">
      <ul class="site-container flex flex-col py-3">
        @for (link of links; track link.section) {
          <li>
            <a
              [appSectionLink]="link.section"
              (click)="menuOpen.set(false)"
              class="block py-3 font-bold text-primary"
              [class.text-gold]="activeSection() === link.section"
            >
              {{ link.label }}
            </a>
          </li>
        }
        <li class="pt-3 pb-2">
          <a
            appSectionLink="contato"
            (click)="menuOpen.set(false)"
            class="flex justify-center rounded-lg bg-primary px-6 py-3 font-bold text-white hover:bg-primary-hover"
          >
            Agendar demonstração
          </a>
        </li>
      </ul>
    </div>
  }
</header>
